import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 8px;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.palette.common.white};
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 20px 12px 12px 12px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const EmptySearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
  gap: 8px;
`;

export const EmptySearchTitle = styled.p`
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
`;

export const EmptySearchDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 400;
  margin: 0;
`;

export const EmptySearchHelper = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  font-weight: 400;
  margin: 4px 0 0 0;
`;
